import { Camera, Object3D, Quaternion, Scene, Vector3 } from 'three';

import { isDefined } from '../../../utils/variables';
import { subscribe, SubscriptionTopic } from '../../messaging/pubsub';
import { ElementObj } from '../element-obj';
import { Poi } from '../poi/poi';
import { PanoramaSphere } from './panorama-sphere';

export class PanoramaManager extends Scene {
  private panoramaSphere: PanoramaSphere;

  private activePanoramaPoi?: Poi;

  private panoramaParent: Object3D;

  constructor(private camera: Camera) {
    super();
    this.panoramaSphere = new PanoramaSphere();
    this.panoramaParent = new Object3D();

    // Apply rotation to ensure Z as "up".
    this.panoramaParent.quaternion.copy(
      new Quaternion().setFromAxisAngle(new Vector3(1, 0, 0), Math.PI / 2),
    );

    this.add(this.panoramaParent);
    this.panoramaParent.add(this.panoramaSphere);
    this.panoramaParent.add(camera);

    const resolveChangingPoi = async (asset: ElementObj) => {
      if (asset instanceof Poi === false || !asset.is360Poi()) {
        return;
      }

      await this.moveToPoi(asset);

      asset.displayCircleIndicator(false);
    };

    subscribe(SubscriptionTopic.AssetChanged, async (asset: ElementObj) => {
      await resolveChangingPoi(asset);
    });
    subscribe(SubscriptionTopic.AssetSelectedInViewer, async (asset: ElementObj) => {
      await resolveChangingPoi(asset);
    });
  }

  getPanoramaSphere() {
    return this.panoramaSphere;
  }

  private async moveToPoi(poi: Poi) {
    // Place sphere at the pano's world position
    this.panoramaParent.position.copy(poi.position);
    if (poi.has360RotationMetadata) {
      this.panoramaSphere.quaternion.copy(poi.getPanoramaRotationEuler(90));
    } else {
      this.panoramaSphere.quaternion.copy(poi.quaternion);
    }

    this.panoramaParent.position.copy(poi.position);

    poi.displayCircleIndicator(true);

    const imageUrl = poi.getThumbnailResourceUrl('original');
    if (!isDefined(imageUrl)) {
      return;
    }
    try {
      await this.panoramaSphere.setPoi(poi);
    } catch (e) {
      console.warn('Pano load cancelled/failed', e);
    }
  }
}
